import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MainPipe } from '@app/shared/helpers/pipes/main-pipe.module';

import { XuxDndItemComponent } from './xux-dnd-item/xux-dnd-item.component';
import { XuxDndListComponent } from './xux-dnd-list/xux-dnd-list.component';
import { DMSharedComponentsModule } from '@geniuspos/ui-shared/modules/xdm-shared-components';
import { XVIComponentsModule } from '../xvi.components.module';
import { XuxDndItemContainerComponent } from './xux-dnd-item-container/xux-dnd-item-container.component';
import { XuxDndListService } from './services/xux-dnd-list.service';

const components = [
  XuxDndListComponent,
  XuxDndItemComponent,
  XuxDndItemContainerComponent,
];

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MainPipe,
    DragDropModule,
    DMSharedComponentsModule,
    XVIComponentsModule,
  ],
  declarations: [...components],
  exports: [...components],
  entryComponents: [XuxDndItemComponent],
  providers: [XuxDndListService],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class XuxDragModule {}
